/**
 * Created by Administrator on 2017/6/29.
 */
export default{
  data () {
    return {
      baseUrl: 'http://sso.tuling123.com/sso-api',
      ReturnURl: ''
    };
  },
  created () {
    if (this.getUrlFn('ReturnURL')) {
      this.ReturnURl = this.getUrlFn('ReturnURL');
      localStorage.setItem('ReturnURL', this.getUrlFn('ReturnURL'));
    } else {
      if (localStorage.getItem('ReturnURL')) {
        this.ReturnURl = localStorage.getItem('ReturnURL');
      } else {
        this.ReturnURl = 'http://www.tuling123.com/member/index.jhtml';
      }
    }
    this.ReturnURl = unescape(this.ReturnURl);
  },
  methods: {
    /* 获取url参数 */
    getUrlFn (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/public.js